import React from 'react';

const BaseCard = ({ children, className = '' }) => (
  <div className={`bg-gradient-to-b from-slate-900 to-slate-900/95 border border-white/10 rounded-xl relative overflow-hidden backdrop-blur-md shadow-lg w-full ${className}`}>
    {children}
  </div>
);

export default BaseCard;